export default __webpack_public_path__ + "static/media/upi.6307d369.webp";